export default {
  GET_ONE: `#graphql
  query getArticleDefault($article: String, $person: String, $design: String) {
    getArticleDefault(article: $article, person: $person, design: $design)
    { 
      priceUnit,
      priceWholesaler,
      priceSale,
      order,
      imagesMeasure,
      texts,
      keywords,
      cost
    }            
  }`,

  GET_ALL: `#graphql
  query getArticleDefaults($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getArticleDefaults(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        articleDefault,
        article,
        person,
        design,
        priceUnit,
        priceWholesaler,
        priceSale,
        order,
        imagesMeasure,
        texts,
        keywords,
        cost
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getArticleDefaultsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getArticleDefaultsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        articleDefault,
        article,
        person,
        design,
        priceUnit,
        priceWholesaler,
        priceSale,
        transaction,
        createdAt,
        createdBy,
        updatedBy,
        cost
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewArticleDefault($articleDefault: ArticleDefaultInput!) {
    newArticleDefault(input: $articleDefault)
    {
      articleDefault,
      article,
      person,
      design,
      priceUnit,
      priceWholesaler,
      priceSale,
      cost
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateArticleDefault($articleDefault: String!, $articleDefaultUpdate: ArticleDefaultUpdateInput!) {
    updateArticleDefault(articleDefault:$articleDefault, articleDefaultUpdate: $articleDefaultUpdate)
    {
      articleDefault
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteArticleDefault($articleDefault: String!) {
    deleteArticleDefault(articleDefault:$articleDefault)
    {
      articleDefault
    }            
  }`,

  UPDATE_PRODUCTS: `#graphql
  mutation UpdateProductsDefault($article: String!, $person: String!, $design: String!, $updatePrices: Boolean, $updateCosts: Boolean, $updateImages: Boolean, $updateKeywords: Boolean, $force: Boolean) {
    updateProductsDefault(article: $article, person: $person, design: $design, updatePrices: $updatePrices, updateCosts: $updateCosts, updateImages: $updateImages, updateKeywords: $updateKeywords, force: $force)
    {
      productsUpdated,
      errors {
        product,
        error
      }
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/articleDefault.js